export default __webpack_public_path__ + "static/media/Snd_TryB.df03038a.mp3";